import React, { cloneElement, useEffect, useState } from "react";
import "./Orders.css";
import Container from "react-bootstrap/Container";
import { Row, Card, Col, Modal, Form } from "react-bootstrap";
import Sidebar from "../../components/Sidebar/Sidebar";
import {
  DeleteOrderDoc,
  OrderDetailsByID,
  UpdateOrder,
  UpdateOrderStatus,
} from "../../apis/OrderAPI";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import dateFormat from "dateformat";
import * as BsIcons from "react-icons/bs";
import * as MdIcons from "react-icons/md";
import { ComboBox, DropDownList } from "@progress/kendo-react-dropdowns";
import { GetInvestigatorsName } from "../../apis/InvestigatorAPI";
import {
  GetBase64,
  ShowDocument,
  ShowOrderDocument,
} from "../../utils/Utility";
import { confirmAlert } from "react-confirm-alert";
import { GetCustomerAllReports } from "../../apis/ReportsAPI";
import { GetCustomerBillingEntity } from "../../apis/CustomerAPI";
import { GetTaxInformation } from "../../apis/MiscAPI";
import { useAlert } from "react-alert";
import Loader from "../../components/Loader";
import { useSelector } from "react-redux";

export default function EditOrder() {
  const alert = useAlert();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const [searchParams] = useSearchParams();
  const orderid = searchParams.get("id");
  const [orderdata, setOrderData] = useState({});
  const [reportData, setReportData] = useState([]);
  const [formDetail, setFormDetail] = useState([]);
  const [miscData, setMiscData] = useState([]);
  const [investigatorList, setInvestigatorList] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [reportAttachments, setReportAttachments] = useState([]);
  const [applicant, setApplicant] = useState("");
  const [address, setAddress] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [coapplicant, setcoApplicant] = useState("");
  const [billingEntity, setBillingEntity] = useState({
    billing_entity_id: 0,
    billing_entity_name: "",
  });
  const [po, setPO] = useState("");
  const [reference, setReference] = useState("");
  const [restriction, setRestriction] = useState("");
  const [adminInstruction, setAdminInstruction] = useState("");
  const [billingEntities, setBillingEntities] = useState([]);
  const [taxRates, setTaxRates] = useState([]);
  const [taxError, setTaxError] = useState(false);

  const [showSaveLoader, setShowSaveLoader] = useState(false);
  const [totalOrderPrice, setTotalOrderPrice] = useState(0);
  var orderAmt = 0;

  const defaultTaxRate = {
    tax_id: 0,
    province: "Choose Tax Rate...",
  };
  const [taxRate, setTaxRate] = useState(defaultTaxRate);

  const defaultInvestigator = {
    id: "0",
    investigatorName: "Choose Investigator....",
  };
  const [investigator, setInvestigator] = useState(defaultInvestigator);

  const [requestorAddrs, setRequestorAddrs] = useState([]);
  const defaultRequestorAddress = {
    id: 0,
    address: "Choose address...",
  };
  const [requestorAddr, setRequestorAddr] = useState(defaultRequestorAddress);

  async function GetOrderData() {
    var result = await OrderDetailsByID(orderid, "edit");
    var data = result.data;
    let order = data.item1;
    setOrderData(order);
    setFormDetail(data.item5);
    setApplicant(order.order_applicant_name);
    setAddress(order.order_address);
    setDueDate(dateFormat(order.order_end_date, "yyyy-mm-dd"));
    setcoApplicant(order.order_co_applicant);
    setPO(order.order_po);
    setReference(order.order_ref);
    setRestriction(order.customer_restrictions);
    setAdminInstruction(order.order_admin_instruction);

    let ttlamt = parseFloat(0);

    //map misc prices
    let miscs = data.item2;
    let miscPrices = [];
    miscs.map((item) => {
      ttlamt += parseFloat(item.misc_price);
      miscPrices.push({
        misc_price_id: item.misc_price_id,
        misc_price: item.misc_price,
        misc_note: item.misc_note,
        is_deleted: 0,
      });
    });
    setMiscData(miscPrices);

    //map reports
    let rpts = data.item3;
    let rptList = [];
    rpts.map((item) => {
      ttlamt += parseFloat(item.reportprice);
      rptList.push({
        report_id: item.report_id_ref,
        mapping_id: item.order_report_mapping_id,
        report_name: item.report_name,
        template_id: item.report_template_id,
        is_primary: item.is_primary ? 1 : 0,
        report_price: item.reportprice,
        is_deleted: 0,
      });
    });
    setReportData(rptList);

    setTotalOrderPrice(ttlamt);

    //map attachments
    let attachs = data.item4.filter((a) => a.attachment_type === "order");
    let attList = [];
    attachs.map((item) => {
      attList.push({
        id: item.order_attachment_id,
        documentName: item.attachment_name,
        documentPath: null,
        attachmentType: "order",
      });
    });
    setAttachments(attList);
    setReportAttachments(
      data.item4.filter((a) => a.attachment_type === "report")
    );

    let reqAddrs = data.item6;
    let addrs = [];
    reqAddrs.map((item) => {
      addrs.push({ id: item.address_id, address: item.requestor_address });
    });

    if (order.requestor_address_id == null && addrs.length > 0)
      setRequestorAddr(addrs[0]);
    else
      setRequestorAddr(
        addrs.filter((x) => x.id === order.requestor_address_id)[0]
      );

    setRequestorAddrs(addrs);

    let invg = investigatorList.filter(
      (x) => x.id === order.order_investigator_id
    );
    setInvestigator(invg[0]);

    let tax = taxRates.filter((t) => t.tax_id === order.tax_id);
    if (tax.length > 0) setTaxRate(tax[0]);
  }

  async function GetInvestigators() {
    var result = await GetInvestigatorsName();
    var data = result.data;
    setInvestigatorList(data);
  }

  async function GetTaxRates() {
    var result = await GetTaxInformation();
    var data = [];
    for (var i = 0; i < result.data.length; i++) {
      data.push({
        tax_id: result.data[i].tax_id,
        province: `${result.data[i].province} - ${result.data[i].tax_percentage}%`,
      });
    }
    setTaxRates(data);
  }

  useEffect(() => {
    GetOrderData();
  }, [investigatorList.length, taxRates.length]);

  useEffect(() => {
    GetInvestigators();
    GetTaxRates();
  }, []);

  async function GetCustomerReports() {
    var result = await GetCustomerAllReports(orderdata.customer_id);
    var data = result.data;
    disableReportItems(data, null);
  }

  function disableReportItems(rpts, rptData) {
    if (rpts == null) rpts = reportList;
    if (rptData == null) rptData = reportData;
    let rptList = [];
    rpts.map((item) => {
      let reportExist = rptData.filter(
        (x) => x.report_id == item.report_id && x.is_deleted == false
      );
      let disableItem = false;
      if (reportExist.length > 0) disableItem = true;
      rptList.push({ ...item, disableOption: disableItem });
    });

    setReportList(rptList);
  }

  async function GetBillingEntities() {
    var result = await GetCustomerBillingEntity(orderdata.customer_id);
    var data = result.data;

    if (data.length > 0) {
      let entty = data.filter(
        (x) => x.billing_entity_name === orderdata.billing_entity_name
      )[0];
      setBillingEntity(entty);
    }
    setBillingEntities(result.data);
  }

  useEffect(() => {
    if (orderdata.order_id != undefined) {
      GetCustomerReports();
      GetBillingEntities();
    }
  }, [orderdata.order_id]);

  const [show, setShow] = useState(false);

  const handleClose = () => {
    let rptData = reportData.filter((x) => x.report_id != 0);
    setReportData(rptData);
    setShow(false);
  };
  const handleShow = () => setShow(true);

  const [showMP, setShowMP] = useState(false);
  const handleMiscClose = () => {
    let md = miscData.filter((x) => x.misc_note != "" && x.misc_note != null);
    setMiscData(md);
    setShowMP(false);
  };
  const handleMiscShow = () => setShowMP(true);

  const deleteDoc = async (item) => {
    let id = item.id;
    if (id !== 0) {
      confirmAlert({
        title: "Delete",
        message: "Are you sure want to delete this attachment?",
        buttons: [
          {
            label: "Yes",
            onClick: async () => {
              var result = await DeleteOrderDoc(id);
              if (result.status === 200) {
                alert.success("Attachment deleted", {
                  onOpen: () => {
                    let docs = attachments.filter(
                      (x) => x.documentName !== item.documentName
                    );
                    setAttachments(docs);
                  },
                });
              } else alert.error("Unable to remove attachment");
            },
          },
          { label: "No" },
        ],
      });
    } else {
      let docs = attachments.filter(
        (x) => x.documentName !== item.documentName
      );
      setAttachments(docs);
    }
  };

  function handleFileChange(event) {
    const files = Array.prototype.slice.call(event.target.files);
    let uploadFiles = [];
    let msg = "";
    files.some((file) => {
      if (
        file.size <= 25000000 &&
        !file.type.includes("application/x-msdownload")
      ) {
        GetBase64(file, (result) => {
          uploadFiles.push({
            id: 0,
            documentName: file.name.split(".").slice(0, -1).join("."),
            documentPath: result,
            attachmentType: "order",
          });
          setAttachments([...attachments, ...uploadFiles]);
        });
      } else msg += `${file.name} exceeds the limit of 25mb.`;
      document.getElementById("attach_upload").value = "";
    });
    if (msg !== "") alert.error(msg);
    //console.log(uploadFiles);
  }

  const viewDocument = (item) => {
    let id = item.id;
    if (id === 0) ShowDocument(item.documentPath);
    else ShowOrderDocument(id);
  };

  const defaultReport = {
    report_id: 0,
    mapping_id: 0,
    report_name: "Choose Report...",
    template_id: 0,
    is_primary: 0,
    report_price: 0,
    is_deleted: 0,
  };

  const [reportList, setReportList] = useState([]);

  let handleReport = (mapId, i, e) => {
    let newReport = [...reportData];
    let primary = 0;
    if (i == 0) {
      primary = 1;
    }
    let newValue = {
      report_id: e.report_id,
      mapping_id: mapId,
      report_name: e.report_name,
      template_id: e.report_template_id,
      is_primary: primary,
      report_price: e.report_price,
      is_deleted: 0,
    };
    var oldPrice = newReport[i].report_price;
    newReport[i] = newValue;
    if (!e.disabled) {
      setReportData(newReport);
      //disable selected item from report dropdown option
      disableReportItems(null, newReport);
    }

    calculateTotalOrderPrice(e.report_price, oldPrice);
  };

  function calculateTotalOrderPrice(nwprice, rmvprice) {
    let np, rp, tp;
    if (isNaN(+nwprice)) np = +0;
    else np = parseFloat(+nwprice);
    if (isNaN(+rmvprice)) rp = +0;
    else rp = parseFloat(+rmvprice);
    if (isNaN(+totalOrderPrice)) tp = +0;
    else tp = parseFloat(+totalOrderPrice);
    orderAmt = (tp - rp + np).toFixed(2);
    setTotalOrderPrice(orderAmt);
  }

  const handlePrice = (i, e) => {
    let newReport = [...reportData];
    let oldprice = newReport[i].report_price;
    let newprice = e.target.value;
    newReport[i].report_price = newprice;
    setReportData(newReport);
    calculateTotalOrderPrice(newprice, oldprice);
  };

  let addReport = () => {
    setReportData([...reportData, defaultReport]);
    disableReportItems(null, null);
  };

  let removeReport = (i) => {
    let newReport = [...reportData];
    newReport[i].is_deleted = 1;
    let oldprice = newReport[i].report_price;
    if (newReport[i].mapping_id == 0) newReport.splice(i, 1);
    setReportData(newReport);

    calculateTotalOrderPrice(0, oldprice);
    //enable selected item from report dropdown option
    disableReportItems(null, newReport);
  };

  const defaultMiscPrice = {
    misc_price_id: 0,
    misc_price: 0,
    misc_note: "",
    is_deleted: 0,
  };

  let handleMiscData = (mapId, i, e) => {
    let newMiscData = [...miscData];

    let newValue = {
      misc_price_id: mapId,
      misc_price: miscData[i].misc_price,
      misc_note: e,
      is_deleted: 0,
    };
    newMiscData[i] = newValue;
    setMiscData(newMiscData);
  };

  const handleMiscPrice = (i, e) => {
    let newMiscData = [...miscData];
    let oldprice = newMiscData[i].misc_price;
    let newprice = e.target.value;

    newMiscData[i].misc_price = newprice;
    setMiscData(newMiscData);

    calculateTotalOrderPrice(newprice, oldprice);
  };

  let addMiscPrice = () => {
    setMiscData([...miscData, defaultMiscPrice]);
  };

  let removeMiscPrice = (i) => {
    let newMiscData = [...miscData];
    newMiscData[i].is_deleted = 1;
    let oldprice = newMiscData[i].misc_price;
    if (newMiscData[i].misc_price_id == 0) {
      newMiscData.splice(i, 1);
    }
    setMiscData(newMiscData);

    if (isNaN(totalOrderPrice)) setTotalOrderPrice(0);
    if (isNaN(oldprice)) oldprice = 0;

    calculateTotalOrderPrice(0, oldprice);
  };

  const handleUpdateOrder = async (e) => {
    e.preventDefault();
    var orderStatus = 1;
    if (taxRate.tax_id == 0) setTaxError(true);
    else {
      if (reportData.length == 0 && attachments.length == 0) {
        confirmAlert({
          title: "Save Order",
          message:
            "There is no report added and have no attachments to this order. Do you want to save this order?",
          buttons: [
            {
              label: "Yes",
              onClick: () => saveOrder(orderdata.order_status_id),
            },
            {
              label: "No",
            },
          ],
        });
      } else {
        saveOrder(orderdata.order_status_id);
      }
    }
  };

  const saveOrder = async (orderStatus) => {
    var order = {
      id: orderid,
      totalRows: 0,
      orderApplicantName: applicant,
      orderCoApplicant: coapplicant,
      orderCustomerName: "",
      orderCustomerIdRef: orderdata.customer_id,
      orderUserIdRef: user.userid,
      orderRequestorIdRef: "0",
      orderAddress: address,
      orderNotes: "",
      orderStartDate: "",
      orderEndDate: dueDate,
      orderPo: po,
      orderTaxes: taxRate.tax_id == 0 ? null : taxRate.tax_id + "",
      orderInvestigatorId: investigator === undefined ? "0" : investigator.id,
      orderRestriction: restriction,
      investigatorName: "",
      orderAmount: totalOrderPrice + "",
      orderStatusId: orderStatus + "",
      orderStatusName: "",
      orderPrelimReportDate: "",
      orderTimestamp: "",
      miscPrice: JSON.stringify(miscData),
      userName: "",
      requestorName: "",
      reportId: "0",
      reportsName: "",
      reports: JSON.stringify(reportData),
      individual: orderdata.individual ?? false,
      corporate: orderdata.corporate ?? false,
      other: orderdata.other ?? false,
      otherRemark: orderdata.otherRemark,
      adminInstruction: adminInstruction,
      customerInstruction: "",
      billingInformation: "",
      applicantFormId: 0,
      attachments: attachments,
      orderBillingEntity: JSON.stringify(billingEntity),
      orderRef: reference,
      requestorAddressId: requestorAddr.id,
      needQA: orderdata.do_qa,
    };
    setShowSaveLoader(true);

    var result = await UpdateOrder(order);
    if (result.status === 200) {
      alert.success("Order updated successfully", {
        onClose: () => {
          navigate(`/admin/orderdetail?id=${orderid}`);
        },
      });
    } else
      alert.error("Unable to update order", {
        onClose: () => setShowSaveLoader(false),
      });
  };

  const handleBillingEntity = (event) => {
    let value = event.value;
    if (value && value.billing_entity_id === undefined) {
      value = {
        ...value,
        billing_entity_id: 0,
      };
    }
    setBillingEntity(value);
  };

  const handleItemRender = (li, itemProps) => {
    let props = li.props;
    if (itemProps.dataItem.disableOption && !itemProps.selected) {
      props = { ...props, className: "k-list-item k-disabled" };
    }

    const itemChildren = <span>{li.props.children}</span>;
    return cloneElement(li, props, itemChildren);
  };

  const handleSkipQA = (e) => {
    var skipped = e.target.checked;
    if (!skipped) {
      confirmAlert({
        title: "Skip QA",
        message: "Are you sure want to skip QA process for this order?",
        buttons: [
          {
            label: "Yes",
            onClick: () => {
              setOrderData({
                ...orderdata,
                do_qa: skipped,
              });
            },
          },
          { label: "No" },
        ],
      });
    } else {
      setOrderData({
        ...orderdata,
        do_qa: skipped,
      });
    }
  };

  return (
    <>
      <Container fluid>
        <Row>
          <div className="admin-wrapper">
            <div className="left-section">
              <Sidebar />
            </div>
            <div className="right-section">
              <Container fluid>
                <Row className="mt-5">
                  <Col lg={12} xs={12}>
                    <Card className="notifications-card">
                      <div className="card-head order-head">
                        <div className="card-title h5">Edit Order</div>
                        <Link to="/Admin/Orders" className="back-btn">
                          <BsIcons.BsArrowLeft />
                        </Link>
                      </div>
                      <Row className="detail-box edit-order-box">
                        <Col lg={6} md={12} className="mb-5">
                          <div className="cards-text">
                            <div className="cards-list-group">
                              <div className="cards-list-item grayout">
                                <span>Order No:</span> {orderdata.order_id}
                              </div>
                              <div className="cards-list-item grayout">
                                <span>Order Date:</span>{" "}
                                {dateFormat(
                                  orderdata.order_start_date,
                                  "mm/dd/yyyy"
                                )}
                              </div>
                              <div className="cards-list-item grayout">
                                <span>Customer Name:</span>{" "}
                                {orderdata.customer_first_name}{" "}
                                {orderdata.customer_last_name}
                              </div>
                              <div className="cards-list-item grayout">
                                <span>Customer No:</span>{" "}
                                {orderdata.customer_id}
                              </div>
                              <div className="cards-list-item grayout">
                                <span>Requestor:</span>{" "}
                                {orderdata.requestor_first_name}{" "}
                                {orderdata.requestor_last_name}
                              </div>
                              <div className="cards-list-item">
                                <span>Requestor Address:</span>
                                <div className="form-group combo-inline">
                                  <DropDownList
                                    className="form-control custom-form-control-select"
                                    data={requestorAddrs}
                                    textField="address"
                                    dataItemKey="id"
                                    defaultItem={defaultRequestorAddress}
                                    value={requestorAddr}
                                    onChange={(e) => {
                                      setRequestorAddr(e.target.value);
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="cards-list-item msgbox">
                                <span>Applicant:</span>{" "}
                                <textarea
                                  value={applicant || ""}
                                  className="form-control"
                                  onChange={(e) => setApplicant(e.target.value)}
                                ></textarea>
                              </div>
                              <div className="cards-list-item msgbox">
                                <span>Co-Applicant:</span>{" "}
                                <textarea
                                  value={coapplicant || ""}
                                  className="form-control"
                                  onChange={(e) =>
                                    setcoApplicant(e.target.value)
                                  }
                                ></textarea>
                              </div>
                              <div className="cards-list-item msgbox">
                                <span>Address:</span>{" "}
                                <textarea
                                  value={address || ""}
                                  className="form-control"
                                  onChange={(e) => setAddress(e.target.value)}
                                ></textarea>
                              </div>
                              <div className="cards-list-item">
                                <span>Due Date:</span>{" "}
                                <input
                                  type="date"
                                  className="form-control"
                                  value={dueDate || ""}
                                  onChange={(e) => {
                                    setDueDate(e.target.value);
                                  }}
                                />
                              </div>
                              <div className="cards-list-item grayout">
                                <span>Prelim Report Date:</span>{" "}
                                {orderdata.order_prelim_report_date &&
                                  dateFormat(
                                    orderdata.order_prelim_report_date,
                                    "mm/dd/yyyy"
                                  )}
                              </div>
                              <div className="cards-list-item grayout">
                                <span>Completion Date:</span>{" "}
                                {orderdata.order_completion_date &&
                                  dateFormat(
                                    orderdata.order_completion_date,
                                    "mm/dd/yyyy"
                                  )}
                              </div>
                              <div className="cards-list-item">
                                <span>Tax Rate:</span>{" "}
                                <div className="form-group combo-inline">
                                  <DropDownList
                                    className="form-control custom-form-control-select"
                                    data={taxRates}
                                    textField="province"
                                    dataItemKey="tax_id"
                                    defaultItem={defaultTaxRate}
                                    value={taxRate}
                                    onChange={(e) => {
                                      setTaxRate(e.target.value);
                                      if (e.target.value.tax_id != 0)
                                        setTaxError(false);
                                    }}
                                    style={{
                                      borderColor: taxError ? "red" : "#ced4da",
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="cards-list-item">
                                <span>Applicant Form:</span>{" "}
                                {formDetail.map((item) => (
                                  <p key={item.application_id}>
                                    <span>
                                      <Link
                                        to={`/Form?token=view&id=${item.form_id}&applicationid=${item.application_id}`}
                                        target="_blank"
                                      >
                                        {item.form_name}
                                      </Link>
                                    </span>
                                  </p>
                                ))}
                              </div>
                              <div className="cards-list-item">
                                <span>Attachment(s):</span>{" "}
                                {attachments.map((item) => (
                                  <p key={item.id}>
                                    <span>
                                      <Link
                                        to={`?id=${orderid}`}
                                        onClick={() => viewDocument(item)}
                                      >
                                        {item.documentName}
                                      </Link>{" "}
                                      <button
                                        type="button"
                                        className="deltbtnbox"
                                        onClick={() => deleteDoc(item)}
                                      >
                                        <MdIcons.MdDeleteForever />
                                      </button>
                                    </span>
                                  </p>
                                ))}
                                <input
                                  id="attach_upload"
                                  className="form-control"
                                  type="file"
                                  multiple
                                  onChange={handleFileChange}
                                />
                              </div>
                              <div className="cards-list-item">
                                <span>Report Attachment(s):</span>{" "}
                                {reportAttachments.map((item) => (
                                  <p key={item.id}>
                                    <span>
                                      <Link
                                        to={`?id=${orderid}`}
                                        onClick={() => viewDocument(item)}
                                      >
                                        {item.documentName}
                                      </Link>{" "}
                                    </span>
                                  </p>
                                ))}
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col lg={6} md={12} className="mb-5">
                          <div className="cards-text">
                            <div className="cards-list-group">
                              <div className="cards-list-item grayout">
                                <span>Status:</span>{" "}
                                {orderdata.order_status_name}
                              </div>

                              <div className="cards-list-item">
                                <span>Billing Entity:</span>{" "}
                                <div className="form-group combo-inline">
                                  <ComboBox
                                    className="form-control custom-form-control-select"
                                    data={billingEntities}
                                    textField="billing_entity_name"
                                    dataItemKey="billing_entity_id"
                                    placeholder="Choose Billing Entity..."
                                    value={billingEntity}
                                    onChange={handleBillingEntity}
                                    allowCustom={true}
                                  />
                                </div>
                              </div>
                              <div className="cards-list-item">
                                <span>Re/PO#:</span>{" "}
                                <input
                                  type="text"
                                  className="form-control"
                                  value={po || ""}
                                  onChange={(e) => setPO(e.target.value)}
                                />
                              </div>
                              <div className="cards-list-item msgbox">
                                <span>References:</span>
                                <textarea
                                  value={reference || ""}
                                  className="form-control"
                                  onChange={(e) => setReference(e.target.value)}
                                ></textarea>
                              </div>
                              <div className="cards-list-item">
                                <span>Investigator:</span>{" "}
                                <div className="form-group combo-inline">
                                  <DropDownList
                                    className="form-control custom-form-control-select"
                                    data={investigatorList}
                                    textField="investigatorName"
                                    dataItemKey="id"
                                    defaultItem={defaultInvestigator}
                                    value={investigator}
                                    onChange={(e) =>
                                      setInvestigator(e.target.value)
                                    }
                                  />
                                </div>
                              </div>
                              <div className="cards-list-item">
                                <span>Report Type:</span>
                                {reportData.map((item, indx) =>
                                  item.is_deleted ? (
                                    ""
                                  ) : (
                                    <p key={"rd_" + indx}>
                                      {!item.is_primary ||
                                      item.template_id == 2 || item.template_id == null ? (
                                        item.report_name
                                      ) : orderdata.order_status_name ===
                                        "New" ? (
                                        <Link
                                          to={`/Report?type=preview&id=${item.template_id}`}
                                          target="_blank"
                                        >
                                          {item.report_name}
                                        </Link>
                                      ) : (
                                        <Link
                                          to={`/Report?type=view&id=${item.mapping_id}`}
                                          target="_blank"
                                        >
                                          {item.report_name}
                                        </Link>
                                      )}{" "}
                                      - ${item.report_price}
                                    </p>
                                  )
                                )}
                                <Link
                                  to={`/Admin/EditOrder?id=${orderid}`}
                                  variant="primary"
                                  onClick={handleShow}
                                >
                                  {" "}
                                  Add
                                </Link>
                              </div>
                              <div className="cards-list-item">
                                <span>Report For:</span>
                                <div className="chkbx">
                                  <Form.Group
                                    controlId="ReportFor"
                                    className="mb-3"
                                  >
                                    <Form.Check
                                      type="checkbox"
                                      inline
                                      label="Individual"
                                      value="individual"
                                      checked={orderdata.individual}
                                      disabled
                                    />
                                    <Form.Check
                                      type="checkbox"
                                      inline
                                      label="Corporate"
                                      value="corporate"
                                      checked={orderdata.corporate}
                                      disabled
                                    />
                                    <Form.Check
                                      type="checkbox"
                                      inline
                                      label="Other"
                                      value="other"
                                      checked={orderdata.other}
                                      disabled
                                    />
                                    {orderdata.other && (
                                      <p>
                                        <span>Report Remark:</span>
                                        {orderdata.other_text}
                                      </p>
                                    )}
                                  </Form.Group>
                                </div>
                              </div>
                              <div className="cards-list-item">
                                <span>Miscellaneous Price:</span>
                                {miscData.map((item, indx) =>
                                  item.is_deleted ? (
                                    ""
                                  ) : (
                                    <p key={"mp_" + indx}>
                                      {item.misc_note} - ${item.misc_price}
                                    </p>
                                  )
                                )}
                                <Link
                                  to={`/Admin/EditOrder?id=${orderid}`}
                                  variant="primary"
                                  onClick={handleMiscShow}
                                >
                                  {" "}
                                  Add
                                </Link>
                              </div>
                              <div className="cards-list-item grayout">
                                <span>Total Order Price:</span> $
                                {totalOrderPrice}
                              </div>
                              <div className="cards-list-item msgbox">
                                <span>Restriction:</span>{" "}
                                <textarea
                                  value={restriction || ""}
                                  className="form-control"
                                  onChange={(e) =>
                                    setRestriction(e.target.value)
                                  }
                                ></textarea>
                              </div>
                              <div className="cards-list-item grayout">
                                <span>Customer Billing Information:</span>{" "}
                                {orderdata.order_billing_information}
                              </div>
                              <div className="cards-list-item grayout">
                                <span>Other Instructions (from Customer):</span>{" "}
                                {orderdata.order_customer_instruction}
                              </div>
                              <div className="cards-list-item msgbox">
                                <span>Other Instructions (from Admin):</span>{" "}
                                <textarea
                                  value={adminInstruction || ""}
                                  className="form-control"
                                  onChange={(e) =>
                                    setAdminInstruction(e.target.value)
                                  }
                                ></textarea>
                              </div>
                              <div className="cards-list-item">
                                <Form.Group controlId="NeedQA" className="mb-3">
                                  <Form.Label className="mr-2">
                                    Need QA:
                                  </Form.Label>{" "}
                                  <Form.Check
                                    type="checkbox"
                                    inline
                                    checked={orderdata.do_qa}
                                    disabled={
                                      orderdata.order_status_id !== 1 &&
                                      orderdata.order_status_id !== 6 &&
                                      orderdata.order_status_id !== 8
                                    }
                                    label=""
                                    onChange={(e) => handleSkipQA(e)}
                                  />
                                </Form.Group>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <div className="ordbtn row">
                        <div className="btorng col-lg-6 col-md-12">
                          <button
                            type="submit"
                            className="btn btn-primary"
                            onClick={handleUpdateOrder}
                          >
                            Save{" "}
                            <Loader visible={showSaveLoader} ibutton={true} />
                          </button>
                        </div>
                        <div className="btgry col-lg-6 col-md-12">
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() =>
                              navigate(`/admin/orderdetail?id=${orderid}`)
                            }
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </Row>
      </Container>
      <Modal show={show} onHide={handleClose} className="addreport-popmodal">
        <Modal.Header closeButton>
          <Modal.Title>Add Report</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="row">
              {reportData.map((item, index) =>
                item.is_deleted ? (
                  ""
                ) : (
                  <Row key={item.mapping_id}>
                    <Col lg={6} md={12}>
                      <div className="cards-text">
                        <div className="cards-list-group">
                          <div className="cards-list-item">
                            <Row>
                              <Col lg={3} md={12}>
                                <Form.Label>
                                  {" "}
                                  {item.is_primary || index === 0
                                    ? "Report Type"
                                    : "Other Type"}
                                  :
                                </Form.Label>
                              </Col>
                              <Col lg={9} md={12}>
                                <DropDownList
                                  className="custom-form-control-select"
                                  data={reportList}
                                  textField="report_name"
                                  dataItemKey="report_id"
                                  defaultItem={defaultReport}
                                  value={item}
                                  itemRender={handleItemRender}
                                  onChange={(e) =>
                                    handleReport(
                                      item.mapping_id,
                                      index,
                                      e.target.value
                                    )
                                  }
                                />
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </Col>

                    <Col lg={6} md={12}>
                      <Form.Group controlId="formBasicText">
                        <Row>
                          <Col lg={4} md={12}>
                            <Form.Label>Report Price:</Form.Label>
                          </Col>
                          <Col lg={7} md={12}>
                            <Form.Control
                              type="number"
                              value={reportData[index].report_price}
                              required
                              onChange={(e) => handlePrice(index, e)}
                            />
                          </Col>
                          <Col lg={1} md={12}>
                            <div className="assign-delt">
                              {index ? (
                                <Link
                                  to={"/Admin/EditOrder?id=" + orderid}
                                  type="button"
                                  className="button remove"
                                  onClick={() => removeReport(index)}
                                >
                                  <MdIcons.MdDeleteForever />
                                </Link>
                              ) : null}
                            </div>
                          </Col>
                        </Row>
                      </Form.Group>
                    </Col>
                  </Row>
                )
              )}
              <Row>
                <div className="add-report-btn mb-3">
                  <Link
                    to={"/Admin/EditOrder?id=" + orderid}
                    onClick={() => addReport()}
                  >
                    Add Report
                  </Link>
                </div>
              </Row>
              <div className="btorng addrepupdate">
                <button
                  onClick={handleClose}
                  type="button"
                  className="btn btn-primary"
                >
                  OK
                </button>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal
        show={showMP}
        onHide={handleMiscClose}
        className="addreport-popmodal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Miscellaneous Price</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="row">
              {miscData.map((item, index) =>
                item.is_deleted ? (
                  ""
                ) : (
                  <Row key={item.misc_price_id}>
                    <Col lg={6} md={12}>
                      <div className="cards-text">
                        <div className="cards-list-group">
                          <div className="cards-list-item">
                            <Row>
                              <Col lg={3} md={12}>
                                <Form.Label>Note:</Form.Label>
                              </Col>
                              <Col lg={9} md={12}>
                                <Form.Control
                                  type="text"
                                  value={miscData[index].misc_note}
                                  required
                                  onChange={(e) =>
                                    handleMiscData(
                                      item.misc_price_id,
                                      index,
                                      e.target.value
                                    )
                                  }
                                />
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </Col>

                    <Col lg={6} md={12}>
                      <Form.Group controlId="formBasicText">
                        <Row>
                          <Col lg={4} md={12}>
                            <Form.Label>Misc Price:</Form.Label>
                          </Col>
                          <Col lg={7} md={12}>
                            <Form.Control
                              type="number"
                              value={miscData[index].misc_price}
                              required
                              onChange={(e) => handleMiscPrice(index, e)}
                            />
                          </Col>
                          <Col lg={1} md={12}>
                            <div className="assign-delt">
                              <Link
                                to={"/Admin/EditOrder?id=" + orderid}
                                type="button"
                                className="button remove"
                                onClick={() => removeMiscPrice(index)}
                              >
                                <MdIcons.MdDeleteForever />
                              </Link>
                            </div>
                          </Col>
                        </Row>
                      </Form.Group>
                    </Col>
                  </Row>
                )
              )}
              <Row>
                <div className="add-report-btn mb-3">
                  <Link
                    to={"/Admin/EditOrder?id=" + orderid}
                    onClick={() => addMiscPrice()}
                  >
                    Add Price
                  </Link>
                </div>
              </Row>
              <div className="btorng addrepupdate">
                <button
                  onClick={handleMiscClose}
                  type="button"
                  className="btn btn-primary"
                >
                  OK
                </button>
              </div>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}
